import { MotionValue } from "motion";
import { createContext } from "react";

export const ScrollAnimContext = createContext<MotionValue<number>>(new MotionValue(0));
